import { useExploreContext } from './use-explore-context';

export function useExploreFacade() {
    const context = useExploreContext();

    return context.exploreFacade!;
}
